module.exports = __webpack_public_path__ + "img/zhulia-07.20c98467.png";